// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 8C4 3.58172 7.58172 0 12 0C16.4183 0 20 3.58172 20 8V12.6972L22 15.6972V20H2V15.6972L4 12.6972V8ZM13 9L13 6L11 6L11 9L8 9L8 11L11 11V14H13V11H16V9H13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.64453 21C9.07481 22.4457 10.4141 23.5 11.9996 23.5C13.5851 23.5 14.9244 22.4457 15.3547 21H8.64453Z"}}]};

const NotificationAddFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'notification-add-filled',
    ref,
    icon: element,
  },
));

NotificationAddFilledIcon.displayName = 'NotificationAddFilledIcon';

export default NotificationAddFilledIcon;
